import {Injectable} from '@angular/core';
import {Geolocation, GeolocationOptions} from '@ionic-native/geolocation/ngx';

import {Plugins} from '@capacitor/core';
import {Platform} from '@ionic/angular';

@Injectable({
    providedIn: 'root'
})
export class FindGeoLocationService {

    gpsOption: GeolocationOptions = {
        timeout: 3000
    };

    constructor(private geolocation: Geolocation,
                private platform: Platform) {
    }

    async getLat() {
        let lat = 0;

        if ((this.platform.is('android') || this.platform.is('ios'))) {
            await this.geolocation.getCurrentPosition(this.gpsOption).then((resp) => {
                lat = resp.coords.latitude;
                console.log(resp);
            }).catch((error) => {
                console.log('Error getting location', error);
            }).finally(() => {
                return 0;
            });
        } else {
            const coords: any = await Plugins.Geolocation.getCurrentPosition();
            lat = coords.coords.latitude;
        }
        return lat;
    }

    async getLong() {
        let long = 0;
        if ((this.platform.is('android') || this.platform.is('ios'))) {
            await this.geolocation.getCurrentPosition(this.gpsOption).then(resp => {
                long = resp.coords.longitude;
            }).catch((error) => {
                console.log('Error getting location', error);
            }).finally(() => {
                return 0;
            });
        } else {
            const coords: any = await Plugins.Geolocation.getCurrentPosition();
            console.log(coords);
            long = coords.coords.longitude;
        }
        return long;
    }

    /*

    */

    async getCurrentPositionCordova() {
        let resp: any = {};
        resp.latitude = 0.0;
        resp.longitude = 0.0;

        try {
            const result = await this.geolocation.getCurrentPosition(this.gpsOption);
            resp = result.coords;
        } catch (error) {
            console.log('Error getting location', error);
        }
        return resp;
    }

}
